module.exports = window.XMLHttpRequest;



//////////////////
// WEBPACK FOOTER
// ./~/httpplease/lib/xhr-browser.js
// module id = 416
// module chunks = 0